let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3T2XJ")).then(() => parcelRequire('afSyV'));